import axios from "axios";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/common.css'; // app-wide master styles (generic/shared)
import './index.css';
import App from './App';
import { Amplify } from "aws-amplify";
import { awsConfig } from "./aws-exports";

axios.defaults.withCredentials = true;

if (process.env.NODE_ENV === 'development') {
  console.warn = () => {};
  console.info = () => {};
}

try {
  Amplify.configure(awsConfig);
} catch (error) {
  console.error("Error configuring Amplify: ", error);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
